import { useReactToPrint } from "react-to-print";
import { useRef, useEffect } from "react";
import { Button, QRCode } from "antd";
import dayjs from "dayjs";

const SalesPrintComponent = ({ tempBuyList, paymentType, responseData }) => {
    const printRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
        documentTitle: "Satış Bilgi Fişi",
        pageStyle: `
            @page {
                size: 70mm 80mm;
                margin: 0;
            }
            @media print {
                html, body {
                    margin: 0 !important;
                    padding: 0 !important;
                }
            }
        `
    });

    useEffect(() => {
        if (responseData) {
            handlePrint();
            console.log(responseData);
        }
    }, [responseData]);


    function karistir(id) {
        let adim1 = id * 1597; // Asal çarpım
        let sonuc = adim1 ^ 48271; // XOR maskesi
        return sonuc;
    }

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div ref={printRef}>

                {responseData?.passList?.map((item, idx) => (
                    <div
                        key={idx}
                        style={{
                            width: "70mm",
                            minHeight: "80mm",
                            padding: "0mm",
                            boxSizing: "border-box",
                            background: "#fff",
                            breakAfter: "page",
                            pageBreakAfter: "always"
                        }}
                    >
                        <div style={{ textAlign: "center" }}>
                            <h2 style={{ textAlign: "center", fontSize: 13, margin: 0 }}>RAYTAPARK</h2>
                            <div style={{ fontWeight: "bold", fontSize: 10 }}>DAĞ KIZAĞI BİNİŞ BİLETİ</div>
                            <div style={{ fontWeight: "bold", fontSize: 10 }}>ALPINE COASTER 2.0 TICKET</div>
                            <div style={{ fontSize: 10 }}>{dayjs().format("DD.MM.YYYY - HH:mm:ss")}</div>
                        </div>

                        <div style={{ display: "grid", gridTemplateColumns: "repeat(1, 1fr)", gap: "0px", alignItems: "center", marginTop: 0 }}>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <QRCode
                                    size={100}
                                    bordered={true}
                                    value={String(karistir(item.id))}
                                />
                            </div>

                            <div style={{ fontSize: 10, textAlign: "center", display:"flex", justifyContent:"center", gap: 10, alignItems:"center" }}>
                                <div style={{textAlign:"center"}}>
                                    <div>Tarife/Rate</div>
                                    <div style={{ fontWeight: "bold", fontSize: 15 }}>{item.buyDetail.recipeName}</div>
                                </div>

                                <div style={{textAlign:"center"}}>
                                    <div >Fiyat/Price</div>
                                    <div style={{ fontWeight: "bold", fontSize: 15 }}>{item.buyDetail.recipePrice} TL</div>
                                </div>


                            </div>

                        </div>

                        <div style={{ textAlign: "center" }}>
                            <div style={{ fontSize: 10, marginTop:5 }}>Ödeme Tipi / Buy Type : {responseData?.buyType}</div>

                            <div style={{ fontSize: 10, marginTop:5 }}>İyi Eğlenceler! / Have Fun!</div>
                            <div style={{ fontSize: 10, marginTop:5 }}>Bu bilet sadee bugün için gerçerlidir. Biletinizi biniş süresine kadar saklayınız</div>
                            <div style={{ fontSize: 10, marginTop:5 }}>This ticket is valid for today only. Keep your ticket until get on the sled</div>
                            <div style={{ fontSize: 6, fontWeight: "bold", marginTop:5}}>Kvkk Aydınlatma Metinleri: https://raytaparkordu.com/tr/kvkkdetay/fotograf-cekimine-iliskin-ziyaretci-aydinlatma-metni/10</div>
                            <div style={{ fontSize: 6, fontWeight: "bold", marginTop: 5 }}>Kullanım Koşulları: https://raytaparkordu.com/tr/kullanim_kosullari</div>
                            <div style={{ fontSize: 6, fontWeight: "bold", marginTop: 5 }}>info@raytaparkordu.com - www.raytaparkordu.com</div>
                        </div>
                    </div>
                ))}

            </div>

            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: 20, width: "100%" }}>
                <Button onClick={handlePrint} type="primary" block>
                    Yazdır
                </Button>
            </div>
        </div>
    );
};

export default SalesPrintComponent;


